import ReactGA from 'react-ga4';

// Your Google Analytics Measurement ID
const MEASUREMENT_ID = 'G-Z9MNCEC2CV'

// Initialize Google Analytics with automatic tracking
export const initGA = () => {
  try {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
      gtagOptions: {
        send_page_view: false, // We'll manually send page views via hook
      }
    });
    
    // Enable automatic event tracking for common interactions
    enableAutomaticTracking();
    
    // console.log('Google Analytics initialized with automatic tracking');
  } catch (error) {
    console.error('Error initializing Google Analytics:', error);
  }
};

// Track page views (called automatically by usePageTracking hook)
export const trackPageView = (path, title) => {
  try {
    ReactGA.send({ 
      hitType: 'pageview', 
      page: path,
      title: title || document.title
    });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Enable automatic tracking for all common user interactions
const enableAutomaticTracking = () => {
  // Track all button clicks automatically
  document.addEventListener('click', (e) => {
    const target = e.target.closest('button, a[href]');
    if (target) {
      const label = target.textContent?.trim() || target.getAttribute('aria-label') || 'Unknown';
      const isExternal = target.tagName === 'A' && target.href && !target.href.includes(window.location.hostname);
      
      if (isExternal) {
        ReactGA.event({
          category: 'Outbound Link',
          action: 'Click',
          label: target.href,
        });
      } else {
        ReactGA.event({
          category: 'User Interaction',
          action: 'Click',
          label: label,
        });
      }
    }
  }, true);

  // Track form submissions automatically
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const formName = form.name || form.id || form.action || 'Unknown Form';
    ReactGA.event({
      category: 'Form',
      action: 'Submit',
      label: formName,
    });
  }, true);

  // Track scroll depth automatically
  let scrollDepthTracked = {
    25: false,
    50: false,
    75: false,
    90: false,
    100: false
  };

  const trackScroll = () => {
    const scrollPercent = Math.round(
      (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
    );

    Object.keys(scrollDepthTracked).forEach(depth => {
      const depthNum = parseInt(depth);
      if (scrollPercent >= depthNum && !scrollDepthTracked[depth]) {
        scrollDepthTracked[depth] = true;
        ReactGA.event({
          category: 'User Engagement',
          action: 'Scroll Depth',
          label: `${depth}%`,
          value: depthNum,
        });
      }
    });
  };

  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(trackScroll, 150);
  }, { passive: true });

  // Track errors automatically
  window.addEventListener('error', (e) => {
    ReactGA.event({
      category: 'Error',
      action: 'JavaScript Error',
      label: e.message || 'Unknown error',
    });
  });

  // Track unhandled promise rejections
  window.addEventListener('unhandledrejection', (e) => {
    ReactGA.event({
      category: 'Error',
      action: 'Unhandled Promise Rejection',
      label: e.reason?.toString() || 'Unknown error',
    });
  });
};

// eslint-disable-next-line
export default {
  initGA,
  trackPageView,
};
